export const NewListData = [
  {
    id: 1,
    src: '/images/영종도.jpg',
    alt: 'list-img',
    title: '영종도의 밤',
    rate: '4.3',
    intro:
      '해가지면 또 다른 장소가 되어버리는 영종도. 그곳엔 어떤 비밀이 숨겨져 있을까?',
  },
  {
    id: 2,
    src: '/images/하늘.jpg',
    alt: 'list-img',
    title: '하늘',
    rate: '2.5',
    intro:
      '상공 10만피트. 이 중에 스파이가 숨어있다! 돌고 도는 추격전 끝의 종착지는 어디?',
  },
  {
    id: 3,
    src: '/images/도버.jpg',
    alt: 'list-img',
    title: '도버해협의 연인',
    rate: '3.7',
    intro: '도버해협을 배경으로 달콤쌉사름한 두 남여의 러브스토리',
  },
  {
    id: 4,
    src: '/images/붕어.JPG',
    alt: 'list-img',
    title: '김의 영역',
    rate: '4.0',
    intro:
      '여느때와 마찬가지로 주말에 낚시를 간 김씨. 그곳에서 범상치 않은 물고기 한마리를 만나는데?',
  },
  {
    id: 5,
    src: '/images/런던3.jpg',
    alt: 'list-img',
    title: '파라다이스 인 런던',
    rate: '2.5',
    intro: '화려한 런던의 밤. 그 이면에 숨겨져 있는 외로운 자들의 음모',
  },
  {
    id: 6,
    src: '/images/마르세유.jpg',
    alt: 'list-img',
    title: '워킹 인 더 마르세유',
    rate: '3.9',
    intro: '자국민에게 탄압 당하는 난민들. 그들의 끝없는 투쟁이 시작된다.',
  },
  {
    id: 7,
    src: '/images/도버.jpg',
    alt: 'list-img',
    title: '도버해협의 연인',
    rate: '3.7',
    intro: '도버해협을 배경으로 달콤쌉사름한 두 남여의 러브스토리',
  },
  {
    id: 8,
    src: '/images/하늘.jpg',
    alt: 'list-img',
    title: '하늘',
    rate: '2.5',
    intro:
      '상공 10만피트. 이 중에 스파이가 숨어있다! 돌고 도는 추격전 끝의 종착지는 어디?',
  },
  {
    id: 9,
    src: '/images/붕어.JPG',
    alt: 'list-img',
    title: '김의 영역',
    rate: '4.0',
    intro:
      '여느때와 마찬가지로 주말에 낚시를 간 김씨. 그곳에서 범상치 않은 물고기 한마리를 만나는데?',
  },
  {
    id: 10,
    src: '/images/영종도.jpg',
    alt: 'list-img',
    title: '영종도의 밤',
    rate: '4.3',
    intro:
      '해가지면 또 다른 장소가 되어버리는 영종도. 그곳엔 어떤 비밀이 숨겨져 있을까?',
  },
  {
    id: 11,
    src: '/images/런던3.jpg',
    alt: 'list-img',
    title: '파라다이스 인 런던',
    rate: '2.5',
    intro: '화려한 런던의 밤. 그 이면에 숨겨져 있는 외로운 자들의 음모',
  },
  {
    id: 12,
    src: '/images/마르세유.jpg',
    alt: 'list-img',
    title: '워킹 인 더 마르세유',
    rate: '3.9',
    intro: '자국민에게 탄압 당하는 난민들. 그들의 끝없는 투쟁이 시작된다.',
  },
];
